import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const stickyNavBarPdpSelector = createSelector(testTargetOffersSelector, offers => offers.stickyNavBarPdp || Empty.Object);

export { stickyNavBarPdpSelector };
